module.exports = __webpack_public_path__ + "media/images/logo-10902847632182663e4c71dd7a401962.png";